/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Price_P2_BoldInputs */

const es_l7_price_p2_bold = /** @type {(inputs: L7_Price_P2_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`único extra inevitable`)
};

const gl_l7_price_p2_bold = /** @type {(inputs: L7_Price_P2_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`único extra inevitable`)
};

const en_l7_price_p2_bold = /** @type {(inputs: L7_Price_P2_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`only unavoidable extra`)
};

/**
* | output |
* | --- |
* | "only unavoidable extra" |
*
* @param {L7_Price_P2_BoldInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_price_p2_bold = /** @type {((inputs?: L7_Price_P2_BoldInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Price_P2_BoldInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_price_p2_bold(inputs)
	if (locale === "en") return en_l7_price_p2_bold(inputs)
	return es_l7_price_p2_bold(inputs)
});